import { Component, OnInit, Input } from '@angular/core';
import { PaymentRecordAdjustment } from "../../../../payments/models/paymentItem.model";

@Component({
    selector: 'adjustment-view',
    templateUrl: './adjustment-view.component.html',
    styleUrls: ['./adjustment-view.component.scss'],
    standalone: false
})
export class AdjustmentViewComponent implements OnInit {

    @Input() adjustment: PaymentRecordAdjustment = null;
    @Input() applicationNumber: string = "";


    @Input() requestedDate: Date;

   
    constructor() { }

    ngOnInit() {
       
    }

}
